import React from "react";
import { PageIntro } from "../components/PageIntro";
import { WhatWeDo } from "../components/home/WhatWeDo";
import { WaysWeStepIn } from "../components/services/WaysWeStepIn";
import { AcrossBoth } from "../components/services/AcrossBoth";
import { HowWeHelp } from "../components/HowWeHelp";
import { ProblemList } from "../components/ProblemList";
import { ClosingCTA } from "../components/ClosingCTA";
import { photos } from "../data/photography";
export function Services() {
  return <>
      <PageIntro label="Payroll Operations + HR Technology" title="Payroll operations and HR technology — from emergency rescue to ongoing support." image={photos.servicesHero} imageCaption="Complicated work, made calm the moment we’re in the room." data-id="element-902" data-mp="3tafjzbapsrea">
        <p className="mt-10 max-w-2xl text-lg leading-relaxed text-charcoal/80 md:text-xl" data-id="element-903" data-mp="2cuw6ihhll4sy">
          Constant helps organizations run payroll, implement and repair HR technology, improve the processes around
          both, and step in when something goes wrong.
        </p>
      </PageIntro>

      <WhatWeDo label="Two core specialties" heading="Payroll Operations. HR Technology. Equal depth in both." showProcess={false} data-id="element-904" data-mp="1bne6yrepkclt" />
      <WaysWeStepIn data-id="element-905" data-mp="1fopp6bv95vjz" />
      <AcrossBoth data-id="element-906" data-mp="1fo7v9lw2btf8" />
      <HowWeHelp data-id="element-907" data-mp="1fnoew9m29d3b" />
      <ProblemList tone="dark" data-id="element-908" data-mp="1kfzefbcw2wvc" />
      <ClosingCTA title={<>
            Talk to Constant about what’s <em className="text-oxblood" data-id="element-910" data-mp="1pg3rssii3bhc">happening</em>.
          </>} body="Tell us what’s broken, changing, or not working well enough. A senior operator will reply — and tell you plainly where we’d start." data-id="element-909" data-mp="1kh10eavg13ru" />
    </>;
}